/** Primary dimensions shown besides the active param. */
export const FLOAT_LABEL_PRIMARY = 3;

/**
 * Which floating labels to show, highest priority first: the active param (if it has an anchor),
 * then the first `primary` anchored params in form order. Booleans never get a label.
 */
export function pickFloatingLabels<T extends { name: string; type?: string; anchor?: unknown }>(spec: T[], active: string | null, primary = FLOAT_LABEL_PRIMARY, order?: string[]): T[] {
  let anchored = spec.filter((s) => s.anchor && s.type !== "bool");
  if (order?.length) {
    const rank = new Map(order.map((n, i) => [n, i]));
    anchored = [...anchored].sort((a, b) => (rank.get(a.name) ?? 1e9) - (rank.get(b.name) ?? 1e9));
  }
  const out = anchored.slice(0, primary);
  const act = active ? anchored.find((s) => s.name === active) : undefined;
  if (act) return [act, ...out.filter((s) => s !== act)];
  return out;
}
